import * as types from "../actions/actionType";
import * as _ from "lodash";


const accountReducer = (state, action) => {
	if(state===null || state===undefined){
		state={};
	}
	switch (action.type) {
		case types.LOAD_ACCOUNTS_SUCCESS:
			return {
				...state,
				accountMatchBool: action.accounts.input_account_match,
				customerCount: action.accounts.customer_count,
				accounts: _.keyBy(action.accounts.accounts, "account_number"),
				currentAccount: action.accounts.accounts[0].account_number,
				total_amount_due: action.accounts.total_amount_due,
				error: false,
				errorMessage: "",
				token: action.accounts.access_token,
				pcgx:action.pcgx
			};
		case types.LOAD_ACCOUNTS_FAILED:
			return {
				...state,
				error: true,
				errorInfo: action.errorInfo
			};
		case types.IS_IE:
			return {
				...state,
				isIEFlag:action.isIEFlag
			};
		case types.SET_CURRENT_ACCOUNT:
			return {
				...state,
				currentAccount: action.accountNumber
			};
		case types.UPDATE_CURRENT_ACCOUNT:
			let total = 0;
			_.forOwn(action.accountUpdate, accountData => {
				if (accountData.payment_amount >= 0) {
					total += parseFloat(accountData.payment_amount);
				}
				else if(accountData.recurring_enabled && accountData.past_due_amount === 0)
          			total += 0;
        		else {
					total +=
						parseFloat(accountData.minimum_due_amount);
				}
			});
			return {
				...state,
				accounts: action.accountUpdate,
				total_amount_due: total
			}
		default:
			return state;
	}
}

export default accountReducer;



// WEBPACK FOOTER //
// ./src/reducers/accountReducer.js